// extracted by mini-css-extract-plugin
export default {"button":"Button_button__wiIYs","green":"Button_green__jsHpm","right":"Button_right__bo0IZ","black":"Button_black__Y2YzG","no-color":"Button_no-color__H1lVG"};